export function format_currency(amount: number, sign = "$") {
  amount = amount ? Math.floor(amount) : 0;
  return sign + Number(amount).toLocaleString("en-US");
}
